import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ButtonBase } from '@material-ui/core';
import { DialogComponent, Spinner } from '../../../../../../Components';
import { DeleteUserLeave } from '../../../../../../Services'
import { showError, showSuccess, getErrorByName } from '../../../../../../Helper';


export const DeleteLeavesDialog = ({
    parentTranslationPath,
    translationPath,
    activeItem,
    setIsOpenDeleteDialog,
    isOpenDeleteDialog,
    setActiveItem,
    getAllUserLeaves
}) => {
    const { t } = useTranslation(parentTranslationPath);
    const [leaves, setLeaves] = useState({
        leaveFrom: activeItem?.leaveFrom || null,
        leaveTo: activeItem?.leaveTo || null
    });
    const [isLoading, setIsLoading] = useState(false);

    const deleteHandler = useCallback(async () => {
        setIsLoading(true);
        const res = await DeleteUserLeave(activeItem && activeItem.userLeavesId);
        if (!(res && res.status && res.status !== 200)) showSuccess(t(`${translationPath}leave-delete-successfully`))
        else showError(t(`${translationPath}leave-delete-failed`));
        setActiveItem(null);
        getAllUserLeaves();
        setIsLoading(false);
        setIsOpenDeleteDialog(false);
    }, [leaves]);

    return (
        <>
            <Spinner isActive={isLoading} />
            <DialogComponent
                isOpen={isOpenDeleteDialog}
                titleText='delete-leave'
                maxWidth='sm'
                // saveText='delete'
                disableBackdropClick
                dialogContent={(
                    <>
                        <div className='d-flex-column-center'>
                            <Spinner isActive={isLoading} />
                            <span className='mdi mdi-close-octagon c-danger mdi-48px' />
                            <span>
                                {t(`${translationPath}Are-you-sure-you-want-to-Delete`)}
                            </span>
                        </div>
                        <div className='actions-btns'>
                            <ButtonBase
                                id='delete-btn'
                                onClick={deleteHandler}
                                className='btns theme-solid'>
                                {t(`${translationPath}delete`)}
                            </ButtonBase>
                            <ButtonBase id='cancel-btn' onClick={() => {

                                setIsOpenDeleteDialog(false);
                            }} className='btns cancel-btn-wrapper'>
                                {t(`${translationPath}cancel`)}
                            </ButtonBase>
                        </div>

                    </>
                )}
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
            />
        </>
    )
}
DeleteLeavesDialog.propTypes = {
    parentTranslationPath: PropTypes.string.isRequired,
    translationPath: PropTypes.string.isRequired,
}
